import { IconLayer } from '@deck.gl/layers';

/**
 * RSOSIconLayer extends IconLayer, patching a click and hover conflict where
 * hover events are triggered immediately after a click event. This causes
 * features that have respective handling for both click and hover events, like
 * popovers, to close immediately after opening.
 */
class RSOSIconLayer extends IconLayer {
  initializeState() {
    super.initializeState();
    this.state.isClicked = false;
  }

  onHover(info, pickingEvent) {
    // This bugfix suppressed the first hover after a click which causes
    // features like popovers to close immediately after a click.
    if (this.state.isClicked) {
      this.state.isClicked = false;
      return;
    }
    super.onHover(info, pickingEvent);
  }

  onClick(info, pickingEvent) {
    this.state.isClicked = true;
    super.onClick(info, pickingEvent);
  }
}

RSOSIconLayer.layerName = 'RSOSIconLayer';

export default RSOSIconLayer;
